<div class="status-template import-template-edit">
  <div class="row">
    <div class="col-12 d-flex">
      <h3 class="cal-title-ctm title me-auto">
        {{ template?.template_name || 'Edit Workflow' }} Template
      </h3>
      <img
        src="./assets/images/crossblack.svg"
        alt="close model"
        (click)="close()"
        width="24px"
        height="24px"
        class="cross-icon module-screen-icon pointer-cls mt-1"
      />
    </div>
    <div class="col-12">
      <div class="template-meta">
        <div class="template-meta-item">
          <span class="template-meta-label">Template Type:</span>
          <span class="template-meta-value">{{ templateTypeLabel }}</span>
        </div>
        <div class="template-meta-item">
          <span class="template-meta-label">Trigger Type:</span>
          <span class="template-meta-value">{{ subTypeLabel }}</span>
        </div>
        
      </div>
    </div>

    <div class="col-12" *ngIf="isStatusTriggerType">
      <div class="d-flex mb-2 justify-content-between">
        <div>
          <h4 class="cal-title-ctm title me-auto fnt-size">
            Main Task Status<span class="text-danger">*</span>
          </h4>
        </div>
        <div class="me-2 status-select">
          <ng-select
            [items]="statusData"
            bindLabel="status_name"
            [searchable]="false"
            [clearable]="false"
            placeholder="Select status"
            [formControl]="mainTasksStatusFormCtr"
          >
            <ng-template ng-label-tmp let-item="item">
              <span class="badge" [ngStyle]="{ color: item?.status_color, 'background-color': item?.status_color + '15' }">
                <span class="s-icon mx-1" [ngStyle]="{ 'background-color': item?.status_color }"></span>
                <b class="text-capitalize status-selected-cls span-truncate">{{ item?.status_name }}</b>
              </span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <div class="d-flex align-items-center">
                <span class="badge" [ngStyle]="{ color: item?.status_color, 'background-color': item?.status_color + '15' }">
                  <span class="s-icon mx-1" [ngStyle]="{ 'background-color': item?.status_color }"></span>
                  <b class="text-capitalize status-selected-cls span-truncate">{{ item?.status_name }}</b>
                </span>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>

    <div class="col-12" *ngIf="isStatusTriggerType">
      <div class="d-flex justify-content-between">
        <h4 class="cal-title-ctm title me-auto fnt-size d-flex align-items-center">
          Task to Task Status<span class="text-danger">*</span>
        </h4>
        <div class="me-2 status-select">
          <ng-select
            [items]="statusData"
            bindLabel="status_name"
            [searchable]="false"
            [clearable]="false"
            placeholder="Select status"
            [formControl]="statusFormCtr"
          >
            <ng-template ng-label-tmp let-item="item">
              <span class="badge" [ngStyle]="{ color: item?.status_color, 'background-color': item?.status_color + '15' }">
                <span class="s-icon mx-1" [ngStyle]="{ 'background-color': item?.status_color }"></span>
                <b class="text-capitalize status-selected-cls span-truncate">{{ item?.status_name }}</b>
              </span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <div class="d-flex align-items-center">
                <span class="badge" [ngStyle]="{ color: item?.status_color, 'background-color': item?.status_color + '15' }">
                  <span class="s-icon mx-1" [ngStyle]="{ 'background-color': item?.status_color }"></span>
                  <b class="text-capitalize status-selected-cls span-truncate">{{ item?.status_name }}</b>
                </span>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>
  </div>

  <form [formGroup]="form" class="form-main">
    <!-- <input class="input-cls input-1 w-100" [value]="template?.template_name || ''" placeholder="Enter template name" readonly /> -->
    <!-- <div class="add-btn-template">+ Add Task</div> -->

    <div formArrayName="tasks" class="inner-form-field mt-3">
      <div
        *ngFor="let taskCtrl of subTasks.controls; let i = index"
        [formGroupName]="i"
        class="task-group"
      >
        <div *ngIf="i > 0" class="d-flex justify-content-center">
          <img src="./assets/images/below-arrow.svg" class="module-screen-icon" draggable="false" />
        </div>

        <div class="task-name-field">
          <div class="w-100">
            <input
              class="input-cls input-2 w-100"
              type="text"
              formControlName="subtask_name"
              placeholder="Task name"
            />
          </div>
          <div class="d-flex select-delete">
            <div class="select-dropdown-block">
            <ng-select
              [items]="priorityData"
              bindLabel="priority_name"
              formControlName="priority"
              [searchable]="false"
              placeholder="Select priority"
            >
              <ng-template ng-label-tmp let-item="item">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18px"
                    height="18px"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12.36 6L12.44 6.39L12.76 8H18V14H14.64L14.56 13.61L14.24 12H7V6H12.36ZM14 4H5V21H7V14H12.6L13 16H20V6H14.4L14 4Z"
                      [attr.fill]="item?.priority_color"
                    ></path>
                  </svg>
                  <span class="text-capitalize" [ngStyle]="{ color: item?.priority_color }">
                    <b class="text-capitalize status-selected-cls">{{ item.priority_name }}</b>
                  </span>
                </span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div class="d-flex align-items-center">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M12.36 6L12.44 6.39L12.76 8H18V14H14.64L14.56 13.61L14.24 12H7V6H12.36ZM14 4H5V21H7V14H12.6L13 16H20V6H14.4L14 4Z"
                        [attr.fill]="item?.priority_color"
                      ></path>
                    </svg>
                    <span class="text-capitalize" [ngStyle]="{ color: item?.priority_color }">
                      <b class="text-capitalize status-selected-cls">{{ item.priority_name }}</b>
                    </span>
                  </span>
                </div>
              </ng-template>
            </ng-select>
            </div>
          </div>
        </div>

        <div class="app-assignee-block">
          <app-assignee-group-template
            [memberList]="memberList"
            [followerList]="followerList"
            [patchId]="subTasks.value[i]?.assignees?.length ? subTasks.value[i]?.assignees : subTasks.value[i]?.groups"
            [patchFollowerId]="subTasks.value[i]?.follower || []"
            [selectGroupType]="subTasks.value[i]?.assignees?.length ? 'member' : (subTasks.value[i]?.groups?.length ? 'group' : '')"
            [selectedTemplateType]="template?.template_type"
            (selectedId)="selectedId($event, i)"
          ></app-assignee-group-template>
        </div>

        <div class="date-block">
          <div class="start-date" *ngIf="isTimeSheetSetting">
            <label class="label-cls">Start Date</label>
            <input type="number" formControlName="start_date" class="input-cls input-3 w-100" />
          </div>
          <div class="due-date" [ngClass]="{ 'w-100': !isTimeSheetSetting }">
            <label class="label-cls">Due Date</label>
            <input type="number" formControlName="due_date" class="input-cls input-3 w-100" />
          </div>
          <div class="due-date" *ngIf="template?.sub_type === 'on_day_gap'">
            <label class="label-cls">Days Gap</label>
            <input type="number" formControlName="day_gap" class="input-cls input-3 w-100" />
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="d-flex justify-content-end footer-row">
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!isWorkflowEditFormValid || submitBtnDisable"
      (click)="saveTemplate()"
    >
      Submit
    </button>
  </div>
</div>
